var _excluded = ["component", "text", "options", "disabled", "error", "success", "helperText", "value", "className", "onChangeOption"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useOutsideClick } from '@creditas-ui/utilities';
import { Select, Placeholder, Container, SelectedValue } from './Dropdown.style';
import { useDropdown } from './useDropdown';
import { Options } from './Options';
import { ChevronDownIcon } from './ChevronDownIcon';
import { DropdownHelperText } from './DropdownHelperText';

var Dropdown = _ref => {
  var {
    component = 'div',
    text = '',
    options = [],
    disabled = false,
    error,
    success,
    helperText,
    value = null,
    className,
    onChangeOption = () => {}
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    hasSelectedValue,
    selectedValue,
    toggleOptions,
    onSelectOption,
    containerRef,
    toggleOptionsContainer,
    handleOutsideClick
  } = useDropdown(options, disabled, value, onChangeOption);
  useOutsideClick(containerRef, handleOutsideClick);
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    ref: containerRef,
    as: component,
    className: className,
    "aria-disabled": disabled
  }), /*#__PURE__*/React.createElement("input", {
    id: text,
    "aria-label": text,
    type: "hidden",
    value: selectedValue.value
  }), /*#__PURE__*/React.createElement(Select, {
    type: "button",
    onMouseDown: toggleOptionsContainer
  }, /*#__PURE__*/React.createElement(Placeholder, {
    htmlFor: text,
    isDisabled: disabled,
    hasSelectedValue: hasSelectedValue,
    error: Boolean(error)
  }, text), selectedValue && /*#__PURE__*/React.createElement(SelectedValue, {
    "data-testid": "value-selected",
    isDisabled: disabled
  }, selectedValue.text), /*#__PURE__*/React.createElement(ChevronDownIcon, {
    isDisabled: disabled
  })), toggleOptions && /*#__PURE__*/React.createElement(Options, {
    isVisible: toggleOptions,
    options: options,
    selectedValue: selectedValue,
    onSelect: onSelectOption
  }), helperText && !success && !error && /*#__PURE__*/React.createElement(DropdownHelperText, null, helperText), success && !error && /*#__PURE__*/React.createElement(DropdownHelperText, {
    success: true
  }, success), error && !disabled && /*#__PURE__*/React.createElement(DropdownHelperText, {
    error: true
  }, error));
};

export { Dropdown };
//# sourceMappingURL=Dropdown.js.map